import React, { useEffect } from "react";

import { createMarkup } from "../../helpers";

import "./styles.css";

const Alert = ({ data }) => {
	useEffect(() => {
		//window.scrollTo(0, 0);
	}, []);

	return (
		<div className={`alertK ${data.type}`}>
			{data.type === "error" ? (
				<i className="fa fa-times-circle fa-2x" />
			) : data.type === "success" ? (
				<i className="fa fa-check-circle fa-2x" />
			) : data.type === "notice" ? (
				<i className="fa fa-exclamation-circle fa-2x" />
			) : (
				<i className="fa fa-circle-o-notch fa-spin fa-2x" />
			)}
			{data.text && <span dangerouslySetInnerHTML={createMarkup(data.text)} />}
		</div>
	);
};

export default Alert;
